import { NON_PUBLISHABLE_SLUGS } from '../schema/constants.js';

/**
 * Checks if a given slug is publishable.
 *
 * A slug is considered publishable if it is not included in the `NON_PUBLISHABLE_SLUGS` list.
 *
 * @param {string} slug - The slug to check.
 * @returns {boolean} - Returns `true` if the slug is publishable, otherwise `false`.
 */
export const isPublishableApp = (slug) => {
  return !NON_PUBLISHABLE_SLUGS.includes(slug);
};
